'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 拨号页面
 */
var QuickContact = React.createClass({
  render: function () {
    return (<img className="component-SimpleCom"
                 src={assetsHelper.getComponentAsset('QuickContact')}
    />);
  }
});

module.exports = QuickContact;



// WEBPACK FOOTER //
// ./src/views/Components/QuickContact.jsx